<footer class="py-4">
  <div class="flex justify-center items-center">
    <div class="mr-6">
      <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/BeeFundCashback" class="icon facebook" aria-label="BeeFund op Facebook"></a>
    </div>
    <div class="mr-6">
      <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/BeeFundCashback/" class="icon instagram" aria-label="BeeFund op Instagram"></a>
    </div>
  </div>
  <div class="flex justify-center items-center">
    <p>© BeeFund - <a href="/privacy" target="_blank" rel="noopener noreferrer">{{ 'privacybeleid' | translate }}</a></p>
  </div>
</footer>
